// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"a4b1bd97","150":"4a6277f9","278":"0f54836a","387":"13e79c78","422":"72dfa95e","437":"8d99e577","453":"d7446e4a","463":"57a894ab","526":"34fb0a39","587":"ffd3afa5","689":"7eaa29ce","720":"0de59dcc","840":"dfb7cc62","884":"2641a49f","953":"38a27194"}[chunkId] + ".chunk.js";
};